import { render, staticRenderFns } from "./MonthlySurplusTreaty.vue?vue&type=template&id=4b61bef5&"
import script from "./MonthlySurplusTreaty.vue?vue&type=script&lang=js&"
export * from "./MonthlySurplusTreaty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports